import { PolicyAcceptanceModal } from './PolicyAcceptanceModal';
import { usePolicyAcceptance } from '@/contexts/PolicyAcceptanceContext';

export const GlobalPolicyAcceptanceModal = () => {
  const { showPolicyAcceptanceModal, handlePolicyAccepted, handlePolicyDeclined, pendingPolicies } = usePolicyAcceptance();

  return (
    <PolicyAcceptanceModal
      isOpen={showPolicyAcceptanceModal}
      onAccept={handlePolicyAccepted}
      onDecline={handlePolicyDeclined}
      pendingPolicies={pendingPolicies}
    />
  );
};
